angular.module('rental')
    .constant('RentalAgreementCategoryConst', {
        eventUpdate: 'rental-agreement-category.updated'
    })
    .factory('RentalAgreementCategory', function ($resource) {
        return $resource('/crm/api/rental-agreement-category/:id', {id: '@id'}, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        })
    })
    .service('RentalAgreementCategoryService', function ($rootScope, modals, RentalAgreementCategory, RentalAgreementCategoryConst) {
        this.add = params => {
            let entity = {
                id: null,
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            return modals.open('app/rental/agreement-category/edit-modal.html', 'RentalAgreementCategoryDialogController', angular.copy(entity), {}, "$ctrl")
        }
        this.list = () => {
            return modals.open('app/rental/agreement-category/list-modal.html', 'RentalAgreementCategoryListController', {}, {size: 'md'}, "$ctrl")
        }
        this.remove = function (item) {
            return modals.confirmDelete(item.name, () => RentalAgreementCategory.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(RentalAgreementCategoryConst.eventUpdate)))
        }
    })
    .controller('RentalAgreementCategoryListController', function ($scope, data, $uibModalInstance, RentalAgreementCategory, RentalAgreementCategoryService, RentalAgreementCategoryConst) {
        this.RentalAgreementCategoryService = RentalAgreementCategoryService
        this.$onInit = () => {
            this.reload()
        }

        $scope.$on(RentalAgreementCategoryConst.eventUpdate, () => this.reload())

        this.close = () => $uibModalInstance.close()
        this.reload = () => {
            RentalAgreementCategory.list().$promise.then(response => this.items = response)
        }
    })

    .controller('RentalAgreementCategoryDialogController', function ($rootScope, $uibModalInstance, data, toastr, RentalAgreementCategory, RentalAgreementCategoryConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss()

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = RentalAgreementCategory.update(this.item).$promise
            } else {
                promise = RentalAgreementCategory.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(RentalAgreementCategoryConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .directive('rentalAgreementCategoryPicker', function (RentalAgreementCategory, RentalAgreementCategoryService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: false,
            scope: {
                required: "=",
                onChange: "&",
                filterField: "=?",
                modelType: "=?",
                disableList: "=?",
                disableAdd: "=?"
            },
            templateUrl: "app/rental/agreement-category/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.filterStyle = scope.filterField || false
                scope.modelType = scope.modelType || "object"
                scope.disableList = scope.disableList || false
                scope.disableAdd = scope.disableAdd || false

                scope.executeOnChange = scope.onChange || angular.noop

                loadItems()

                function loadItems() {
                    RentalAgreementCategory.list().$promise.then(items => scope.items = items)
                }

                scope.add = () => RentalAgreementCategoryService.add().then(() => loadItems())
                scope.list = () => RentalAgreementCategoryService.list().then(() => loadItems())

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => {
                    return scope.modelType === "id" ? viewValue.id : viewValue
                })

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }
            }
        }
    })
